var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.asset)?_c('asset-states',{attrs:{"asset":_vm.asset,"imei":_vm.asset.reference}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }